export const CategoriesInput = [
    {name:'Ring',value:'Ring',id:4},{name : 'Skewers',value:'Skewers',id:5},{name : 'Pouch',value:'Pouch',id:2},{name : 'Platter',value:'Platter',id:6}
]